<template>
  <b-navbar toggleable="lg" variant="light" fixed="top" sticky>
    <!--    Brand    -->
    <b-navbar-brand to="/">
      <img src="@/assets/logo.png" width="55px">
    </b-navbar-brand>

    <!--    Toggle    -->
    <b-navbar-toggle target="navbar-toggle-collapse">
      <!--      <b-icon icon="list"/>-->
    </b-navbar-toggle>

    <!--    Collapsable Nav    -->
    <b-collapse id="navbar-toggle-collapse" is-nav>
      <b-navbar-nav class="navbar">
        <b-nav-item to="/lecon/b1">DELF B1</b-nav-item>
        <b-nav-item to="/lecon/b2">DELF B2</b-nav-item>
        <b-nav-item to="/lecon/c1">DALF C1</b-nav-item>
        <b-nav-item to="/lecon/c2">DALF C2</b-nav-item>

        <b-nav-item to="/exercices">Exercices</b-nav-item>

        <b-nav-item to="/messagerie" style="position: relative">
          Parle avec Luqei
          <notif-message/>
        </b-nav-item>

        <b-nav-item-dropdown text="Mon compte">
          <b-dropdown-item to="/textes">Mes Ecrits</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Admin" v-if="isAdmin">
          <b-dropdown-item to="/admin/eleves">Eleves</b-dropdown-item>
          <b-dropdown-item to="/admin/exercices">Exercice</b-dropdown-item>
          <b-dropdown-item to="/admin/produits">Produits</b-dropdown-item>
          <b-dropdown-item to="/admin/contenu_principal">Contenu principal</b-dropdown-item>
          <b-dropdown-item to="/admin/dialogues">Dialogues</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <b-navbar-nav class="navbar ml-auto">
        <b-nav-item @click="LogOut">Déconnexion</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import {Auth} from "@/js/caller";
import NotifMessage from "@/components/NotifMessage";

export default {
  name      : "navApp",
  components: {NotifMessage},
  data() {
    return {
      isAdmin: Auth.IsAdmin(),
    }
  },
  methods: {
    LogOut() {
      Auth.LogOut();
    },
  },
  created() {
    Auth.Register(Auth.Events.Role, () => {
      this.isAdmin = Auth.IsAdmin();
    });
  }
}
</script>

<style>
.navbar-nav .nav-link {
  padding: 0.5rem 1rem !important;
  color: #007bff !important;
}

.navbar-nav .nav-link:hover {
  color: #0056b3 !important;
}

</style>